// Holds the one Sign Up pop-up the "/#join" CTAs open. Mounted at the app root
// so it is available on every page, whichever shell renders it.
import React, { useEffect, useState } from "react";
import SignUpModal from "../../Component/SignUpModal";
import { onOpenSignUp } from "../lib/signup-modal";

export default function SignUpModalHost() {
  const [show, setShow] = useState(false);

  useEffect(() => onOpenSignUp(() => {
    setShow(true);
  }), []);

  return <SignUpModal show={show} onHide={() => setShow(false)} />;
}
